module.exports = __webpack_public_path__ + "static/media/IMG_20191127_134644.cb178c3b.jpg";